import Vue from 'vue';

const labels = {
  account: 'Account',
  account_created: 'L\'account è stato creato con successo.<br>Ora puoi loggarti.',
  account_details: 'Dettagli account',
  account_number: 'Numero di conto',
  actions: 'Azioni',
  add: 'Aggiungi',
  add_coupon: 'Applica',
  add_new_card: 'Aggiungi nuova card',
  add_to_cart: 'Aggiungi al carrello',
  added_to_cart: 'Aggiunto al carrello',
  additional_information: 'Informazioni aggiuntive',
  address_1: 'Indirizzo',
  address_2: 'Dettagli indirizzo',
  address_2_placeholder: 'Appartamento, abitazione, unità, ecc.',
  addresses: 'Indirizzi',
  available: 'disponibile',
  back_to_cart: 'Torna al carrello',
  bank: 'Banca',
  bic_swift: 'BIC/SWIFT',
  billing_address: 'Indirizzo di fatturazione',
  cancel_card: 'Cancella la carta',
  cancel_card_dialog: 'Sei sicuro di voler eliminare questa carta?',
  cancel_order: 'Cancella ordine',
  cancel_order_dialog: 'Sei sicuro di voler cancellare quest\'ordine?',
  cannot_pay_for_order: 'Non puoi pagare per questo ordine',
  cart: 'Carrello',
  cart_products: 'Prodotti nel carello',
  cart_summary: 'Riepilogo',
  checkout: 'Checkout',
  choose_option: 'Scegli un opzione',
  city: 'Città',
  close: 'Chiudi',
  company: 'Azienda',
  country: 'Nazione',
  coupon: 'Coupon',
  create_account: 'Crea account',
  create_accunt: 'Crea un account',
  date: 'Date',
  delete: 'Cancella',
  details: 'Dettagli',
  discount: 'Sconto',
  display_name: 'Nome da visualizzare',
  do_you_have_account: 'Hai un account?',
  edit: 'Modifica',
  email: 'Email',
  empty_cart: 'Svuota il carrello',
  ending_in: 'che finisce in',
  error_confirmed_after: '',
  error_confirmed_pre: 'Il campo deve essere lo stesso di',
  error_email: 'L\'email non è valida',
  error_generic: 'Si è verificato un errore',
  error_generic_customer: 'Impossibile ottenere i dati del cliente.',
  error_generic_login: 'Qualcosa è andato storto durante il login. Dovresti accedere di nuovo.',
  error_min_after: 'caratteri',
  error_min_pre: 'Il campo deve avere almeno',
  error_required: 'Il campo è obbligatorio',
  error_user_addresses_update: 'Si è verificato un problema durante il salvataggio dei dati.',
  error_user_update: 'Si è verificato un problema durante il salvataggio dei dati. <br>Controllali prima di riprovare.',
  excluded_vat: 'ex. I.V.A.',
  excluded_vat_extended: 'I.V.A. esclusa',
  expires: 'scade',
  first_name: 'Nome',
  future_payments: 'Pagamenti futuri',
  go_to: 'Vai a',
  go_to_checkout: 'Procedi al checkout',
  go_to_orders: 'Vai ai tuoi ordini',
  go_to_payment: 'Procedi al pagamento',
  go_to_shop: 'Torna allo shop',
  hide_order_summary: 'Nascondi il riepilogo dell\'ordine',
  iban: 'IBAN',
  id: 'ID',
  insert_coupon: 'Inserisci il tuo coupon',
  last_name: 'Cognome',
  logged_in_with_mail: 'Sei loggato con la e-mail',
  login: 'Login',
  logout: 'Logout',
  lost_password: 'Hai dimenticato la password?',
  make_default: 'Rendi predefinito',
  may_be_interested_in: 'Potresti essere interessato a...',
  my_account: 'Mio account',
  no_order: 'Nessun ordine presente.',
  no_saved_card: 'Non hai carte salvate',
  old_password: 'Vecchia password',
  order: 'Ordine',
  order_cancelled: 'Il tuo ordine è stato annullato',
  order_details: 'Dettagli ordine',
  order_failed: 'Purtroppo il tuo ordine non può essere elaborato poiché la banca/commerciante di origine ha rifiutato la transazione. Si prega di riprovare l\'acquisto',
  order_infos: 'Informazioni ordine',
  order_notes: 'Note sull\'ordine',
  order_notes_placeholder: 'Hai bisogno di un giorno di consegna specifico? Invii un regalo? ',
  order_received: 'Il tuo ordine è stato ricevuto',
  order_updated: 'Il tuo ordine è stato aggiornato',
  order_updates: 'Aggiornamenti sugli ordini',
  orders: 'Ordini',
  out_of_stock: 'Esaurito',
  password: 'Password',
  password_placeholder: 'Minimo 6 caratteri',
  pay_for_order: 'Paga per l\'ordine',
  payment: 'Pagamento',
  payment_method: 'Metodo di pagamento',
  payment_methods: 'Metodi di pagamento',
  phone: 'Telefono',
  place_order: 'Invia ordine',
  postcode: 'CAP / Zip',
  product: 'Prodotto',
  products: 'Prodotti',
  profile: 'Profilo',
  refunded: 'Rimborsato',
  register: 'Crea un account',
  remove: 'Rimuovi',
  repeat_password: 'Ripeti password',
  save: 'Salva',
  save_card: 'Salva la carta per pagamenti futuri',
  saved_cards: 'Carte salvate',
  saved_changes: 'I cambiamenti sono stati salvati',
  select_option: 'Seleziona opzione',
  send: 'Invia',
  ship_different_address: 'Spedire a un indirizzo diverso?',
  shipping: 'Spedizione',
  shipping_address: 'Indirizzo di spedizione',
  shipping_exstimated: 'Spedizione stimata',
  shipping_method: 'Metodo di spedizione',
  shipping_methods: 'Metodi di spedizione',
  shipping_methods_empty_states: 'Inserisci il tuo indirizzo per conoscere i metodi di spedizione disponibili.',
  shop: 'shop',
  show_order_summary: 'Mostra il riepilogo dell\'ordine',
  state: 'Stato / Paese',
  status: 'Status',
  subtotal: 'Totale parziale',
  terms: 'Accetto i <a href="https://gua.farm/termini-e-condizioni" target="_blank">termini e le condizioni</a>.',
  thank_you: 'Grazie dell\'ordine!',
  thank_you_error: 'C\'è un problema con il tuo ordine...',
  title_coupon: 'Hai un codice sconto?',
  total: 'Totale',
  totals: 'Totali',
  use_new_card: 'Usa una nuova carta di credito',
  username_email: 'E-mail',
  vat: 'I.V.A.',
  vat_extimated: 'I.V.A. stimata',
  welcome_back: 'Ben tornato',
  wrong_login_data: 'Dati errati. <br>Riprova o reimposta la password.',
  wrong_mail: 'Questa email non è registrata in questo sito.',
  your_cart: 'Il tuo carrello',
  your_cart_empty: 'Il tuo carrello è vuoto',
};

labels.install = () => {
  Vue.prototype.$labels = labels;
};

Vue.use(labels);

export default labels;
